var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.1421 27.4675L32.0059 16.6037C32.3964 16.2132 32.3964 15.58 32.0059 15.1895L30.8488 14.0324C30.4583 13.6419 29.8251 13.6419 29.4346 14.0324L21.6747 21.7923L21.6747 0.999998C21.6747 0.447713 21.227 -4.16962e-08 20.6747 0L19.0383 1.23542e-07C18.486 1.65239e-07 18.0383 0.447715 18.0383 0.999999L18.0383 21.7923L10.2784 14.0324C9.88789 13.6419 9.25473 13.6419 8.8642 14.0324L7.70712 15.1895C7.31659 15.58 7.31659 16.2132 7.70712 16.6037L18.5708 27.4675C19.2809 28.1775 20.4321 28.1775 21.1421 27.4675ZM5.12617 19.1847L15.9899 30.0484C18.1254 32.1839 21.5876 32.1839 23.7231 30.0484L34.5868 19.1847C35.7042 18.0672 36.1341 16.5226 35.8763 15.0765C38.2199 15.4908 40 17.5375 40 20V35C40 37.7614 37.7614 40 35 40H5C2.23858 40 0 37.7614 0 35V20C0 17.6429 1.63104 15.6667 3.82606 15.1386C3.59135 16.5667 4.02472 18.0832 5.12617 19.1847Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDownload);
export default __webpack_public_path__ + "static/media/icon_Download.396118a721a7931a5c1e1cff0d8ae468.svg";
export { ForwardRef as ReactComponent };